<script setup>
import { defineProps} from 'vue';

defineProps({
  year: Number
});
</script>

<template>
  <footer>
    <div class="container">
      <div class="row mb0">
        <div class="col s12 xl4 first">
          <a href="mailto:info@uatradeup.com" class="email">info@uatradeup.com</a>
          <div class="soc">
            <a href="tel:+380670100133" class="phone">+380 (67) 010 01 33</a>
            <a href="tg://resolve?domain=uatradeup"  class="link"><img src="@/assets/img/telegram.svg" alt="telegram"></a>
            <a href="viber://chat?number=+380670100133" class="link"><img src="@/assets/img/viber.svg" alt="viber"></a>
            <a href="https://www.instagram.com/uatradeup?igsh=MWo4M3prNW5venpr" class="link" target="_blank"><img src="@/assets/img/insta.svg" alt="instagram"></a>
          </div>
        </div>
        <div class="col s12 xl4 second">
          <img class="footer_logo" src="@/assets/img/logo.svg">
        </div>
        <div class="col s12 xl4 third">
          <p class="footer_copy">© {{year}} uatradeup.com Усі права захищені </p>
          <a href="/privacy-policy" class="footer_politic">Політика конфіденційності</a>
          <a href="/public-offer" class="footer_offer">Договір оферти</a>
        </div>
      </div>
      <div class="row mb0">
        <div class="col s12 center">
          <a href="https://www.happycode.com.ua" class="happy_code" target="_blank"></a>
        </div>
      </div>
    </div>
  </footer>
</template>



<style scoped>

.center
{
  display: flex;
  justify-content: center;
}

footer
{
  background-color: #181818;
  height: 300px;
  position: relative;
  background-image: url(@/assets/img/all_footer.png);
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: 0px;
  width: 100%;
  display: flex;
  align-items: center;
}

.email
{
  font-family: HeliosExtC;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  position: relative;
  z-index: 2;
}

.soc
{
  display: block;
  position: relative;
  top: -4px;
}

.soc .phone
{
  display: inline-block;
  font-family: HeliosExtC;
  font-size: 12px;
  color: #fff;
  padding-top: 0;
  cursor: pointer;
  position: relative;
  margin-right: 24px;
  z-index: 2;
}

.soc .link
{
  display: inline-block;
  height: 100%;
  width:19px;
  height:17px;
  position: relative;
  top:5px;
  cursor: pointer;
  z-index: 2;
}

.soc .link:nth-child(3)
{
   margin: 0 10px;
}

.footer_logo
{
  display: block;
  margin: 0 auto;
  width: 119px;
}


.footer_copy,
.footer_politic,
.footer_offer
{
  display: block;
  padding: 0;
  margin: 0;
  font-family: HeliosExtThinC;
  font-size: 12px;
  color: #fff;
  text-align: right;
}

.footer_politic
{
  padding: 2px 0;
}

.footer_politic,
.footer_offer
{
  position: relative;
  cursor: pointer;
  z-index: 2;
}

.happy_code
{
  border-radius: 51px;
  padding: 5px 20px;
  height: 34px;
  display: block;
  width: 280px;
  border-radius: 51px;
  border: 1px solid #c8cac842;
  background-image: url("@/assets/img/happy_code_.png");
  background-repeat: no-repeat;
  background-position: center;
  top: 34px;
  position: relative;
  cursor: pointer;
  position: relative;
  z-index: 2;
}

.happy_code:hover
{
  border: 1px solid rgba(255, 255, 255, 0.7);
  background-image: url("@/assets/img/happy_code_next.png");
}

.mb0
{
  margin-bottom: 0!important;
}


/*media*/
@media (max-width: 1200px)
{
  .row.mb0 .col.s12.xl4.first
  {
    text-align: center!important;
  }
  .row.mb0 .col.s12.xl4.second
  {
    display: flex;
    justify-content: center;
    margin: 12px 0;
  }

  .row.mb0 .col.s12.xl4.third a,
  .row.mb0 .col.s12.xl4.third p
  {
    text-align: center;
  }

  .row.mb0 .col.s12.xl4.third .footer_politic
  {
    margin: 12px 0;
  }

  .row.mb0 .col.s12.center .happy_code
  {
    top:12px;
  }
}



</style>